import React from "react";
import { useSelector } from 'react-redux';
import { selectLoggedInUser } from "../../../redux/userSlice";

function NoTableData() {

  const loggedInUser = useSelector(selectLoggedInUser);

  return (
    <>
      <tr>
        {(loggedInUser.flagForHideShow === "ERC") ?
        <td colSpan= {2}>No data found</td>
        :
        <td colSpan= {5}>No data found</td> 
        }
      </tr>
    </>
  );
}

export default NoTableData;